import styled from '@emotion/styled'

const BACKGROUND_CROSSFADE_DURATION_MS = 400

export const CardStudioFullscreen = styled.main<{ $scrollable?: boolean }>`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  overflow: ${({ $scrollable }) => ($scrollable ? 'auto' : 'hidden')};
  overscroll-behavior: none;
  touch-action: ${({ $scrollable }) => ($scrollable ? 'auto' : 'none')};
  background: ${({ theme }) => theme.arcadeColors.semantic.backgroundApp};
`

export const CardStudioBackgroundImage = styled.img<{ $visible?: boolean }>`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: ${({ $visible = true }) => ($visible ? 1 : 0)};
  pointer-events: none;
  transition: opacity ${BACKGROUND_CROSSFADE_DURATION_MS}ms ease;

  @media (prefers-reduced-motion: reduce) {
    transition-duration: 0ms;
  }
`
